import React from 'react';
import { EngagementSpotlight } from '@atlassiansox/engagekit-ts';
import { SpotlightManager, SpotlightTarget } from '@atlaskit/onboarding';
import { useIntl } from '@atlassian/jira-intl';
import { createAri } from '@atlassian/jira-platform-ari';
import JiraShareButton from '@atlassian/jira-share-button';
import { integrationTypes } from '@atlassian/jira-share-button/src/constants';
import { useBacklogSelector } from '../../../../state';
import { getCloudId, getRapidViewId, getName } from '../../../../state/selectors/app';
import messages from './messages';

type Props = {
	shareContentType: string;
	onTriggerButtonClick: () => void;
};

export const ShareButton = ({ shareContentType, onTriggerButtonClick }: Props) => {
	const cloudId = useBacklogSelector(getCloudId);
	const boardId = useBacklogSelector(getRapidViewId);
	const boardName = useBacklogSelector(getName);
	const { formatMessage } = useIntl();

	return (
		<SpotlightManager>
			<SpotlightTarget name="ccEcoBoardBacklogShare">
				<JiraShareButton
					productId="jira"
					subProductId="jira-software"
					shareContentType={shareContentType}
					integrationType={integrationTypes.BOARD}
					shareTitle={boardName}
					shareFormTitle={formatMessage(messages.shareFormTitle)}
					objectAri={createAri({
						resourceOwner: 'jira-software',
						cloudId,
						resourceType: 'board',
						resourceId: boardId,
					})}
					onTriggerButtonClick={onTriggerButtonClick}
					shareFormHelperMessage={formatMessage(messages.shareHelperMessage)}
				/>
			</SpotlightTarget>
			<EngagementSpotlight name="ccEcoBoardBacklogShare" />
		</SpotlightManager>
	);
};
